"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var scrollBar = function scrollBar(trackColor, thumbColor) {
  return "\n  &::-webkit-scrollbar {\n    width: 16px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: ".concat(trackColor, ";\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ").concat(thumbColor, ";\n    background-clip: padding-box;\n    border: 5px solid rgba(0, 0, 0, 0);\n  }\n");
};
var _default = exports.default = scrollBar;